<div class="container mx-auto p-6">
    <h1 class="text-4xl font-bold mb-8">Actualités</h1>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        @for(actualite of actualites; track actualite.key) {
            <app-actualite-card [actualite]="actualite"></app-actualite-card>
        }
    </div>
</div>